var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXraySubTestExecution({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#8FAA2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4048 20.3298L22.7166 16.7794C23.2044 16.505 23.2044 15.8027 22.7166 15.5283L16.4048 11.9779C16.1263 11.8213 15.7823 12.0225 15.7823 12.342V19.9657C15.7823 20.2852 16.1263 20.4864 16.4048 20.3298Z",
    fill: "white",
    stroke: "#8FAA2D",
    strokeWidth: 0.435374
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8815 21.7695L19.5526 16.6457C20.0438 16.3554 20.0438 15.6446 19.5526 15.3543L10.8815 10.2305C10.3816 9.9351 9.75 10.2955 9.75 10.8762V21.1238C9.75 21.7045 10.3816 22.0649 10.8815 21.7695Z",
    fill: "white",
    stroke: "#8FAA2D",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXraySubTestExecution);
export default __webpack_public_path__ + "static/media/xray-sub-test-execution.7f62b4bf828adb27e2f815f2d77ec81d.svg";
export { ForwardRef as ReactComponent };